import {
    getCharMinMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const CLAIM_EVENT_STATUS = 'Claim event status';

const _NOTE_MIN_CHAR = 5;

export const validate = (statusId, notes) => {
    let newErrors = {};

    if (!statusId) {
        newErrors = {
            ...newErrors,
            statusId: { error: true, message: getReqMessage(CLAIM_EVENT_STATUS) }
        };
    }

    if (notes.trim().length < _NOTE_MIN_CHAR) {
        newErrors = {
            ...newErrors,
            notes: { error: true, message: getCharMinMessage('Cannot Claim notes', 5) }
        };
    }

    return newErrors;
};
